<nb-card>
  <div class="form-inline">
    <label *ngIf="!showEditor" class="text-hint link" (click)="editing()">
      {{ date | date : "dd/MM/yyyy" }}
    </label>

    <nb-form-field fullWidth *ngIf="showEditor">
      <button nbPrefix status="basic" nbButton ghost (click)="closeEditor()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>

      <input
        fullWidth
        nbInput
        shape="semi-round"
        [nbDatepicker]="startDate"
        [(ngModel)]="inDate"
      />
      <nb-datepicker #startDate format="dd/MM/yyyy"></nb-datepicker>

      <button nbSuffix status="primary" nbButton ghost (click)="save()">
        <nb-icon icon="save-outline"></nb-icon>
      </button>
    </nb-form-field>
  </div>
</nb-card>
